export const allFacilitiesOptionId = "allFacilities";
